module.exports = __webpack_public_path__ + "img/close-block-lightgrey.8a86d48d.svg";